import theme from '@themes/theme';
import { ToastContainer } from 'react-toastify';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledToastContainer = styled(ToastContainer).attrs({
  className: 'toast-container',
  toastClassName: 'toast',
  bodyClassName: 'body',
  progressClassName: 'progress',
})`
  .toast {
    background-color: ${theme.light.colors.primaryDark};
  }
`;
export const StyledTooltip = createGlobalStyle`
  :root {
    .MuiDataGrid-menu.base-Popper-root {
      & .MuiPaper-root {
        color: ${({ theme }) => theme.colors.textPrimary};
        background-color: ${({ theme }) => theme.colors.paper};

        & .MuiList-root {
          & .MuiListItemIcon-root {
            color: ${({ theme }) => theme.colors.textPrimary};
          }

          & .MuiDivider-root {
            border-color: ${({ theme }) => theme.colors.divider};
          }

          & .MuiMenuItem-root.Mui-selected {
            background-color: ${({ theme }) => theme.colors.secondaryBackground};
          }

          & .MuiMenuItem-root:hover {
            background-color: ${({ theme }) => theme.colors.secondaryBackground};
          }
        }
      }
    }

    .base-Popper-root.MuiDataGrid-panel {
      & .MuiPaper-root {
        color: ${({ theme }) => theme.colors.textPrimary};
        background-color: ${({ theme }) => theme.colors.paper};

        & .MuiDataGrid-columnsManagementHeader {
          & .MuiInputBase-root {
            color: ${({ theme }) => theme.colors.textPrimary};
            background-color: ${({ theme }) => theme.colors.secondaryBackground};

            & .MuiInputAdornment-root {
              color: ${({ theme }) => theme.colors.textPrimary};
            }

            &:hover {
              border-color: ${({ theme }) => theme.colors.divider};
            }
          }
        }

        & .MuiDataGrid-columnsManagementFooter {
          border-top: 1px solid ${({ theme }) => theme.colors.divider};

          & .MuiButton-root {
            color: ${({ theme }) => theme.colors.textPrimary};
          }
        }

        & .MuiDataGrid-columnsManagementRow {
          & .MuiFormControlLabel-label {
            color: ${({ theme }) => theme.colors.textPrimary};
          }
        }

        & .MuiCheckbox-root {
          color: ${({ theme }) => theme.colors.primary};
        }

        & .MuiDataGrid-filterForm {
          & .MuiButtonBase-root {
            color: ${({ theme }) => theme.colors.textPrimary};
          }

          & .MuiSvgIcon-root {
            color: ${({ theme }) => theme.colors.textPrimary};
          }

          & .MuiFormControl-root {
            & .MuiFormLabel-root {
              color: ${({ theme }) => theme.colors.textPrimary};
            }

            & .MuiInputBase-root {
              color: ${({ theme }) => theme.colors.textPrimary};

              &::before {
                border-bottom: 1px solid ${({ theme }) => theme.colors.divider};
              }

              &::after {
                border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
              }
            }
          }
        }

        & .MuiDataGrid-panelFooter {
          & .MuiButtonBase-root {
            color: ${({ theme }) => theme.colors.textPrimary} !important;
          }
        }

      }
    }

    .MuiPopover-paper.MuiMenu-paper {
      color: ${({ theme }) => theme.colors.textPrimary};
      background-color: ${({ theme }) => theme.colors.paper};

      & .MuiList-root {
        & .MuiMenuItem-root.Mui-selected {
          background-color: ${({ theme }) => theme.colors.secondaryBackground};
        }

        & .MuiMenuItem-root:hover {
          background-color: ${({ theme }) => theme.colors.secondaryBackground};
        }
      }
    }
  }
`;
export const StyledDatePicker = createGlobalStyle`
  :root {
    .MuiPickersPopper-root {
      & .MuiPickersPopper-paper {
        color: ${({ theme }) => theme.colors.textPrimary};
        background-color: ${({ theme }) => theme.colors.secondaryBackground};

        & .MuiTypography-root {
          color: ${({ theme }) => theme.colors.textPrimary};
        }

        & .MuiPickersDay-root:not(.Mui-disabled) {
          color: ${({ theme }) => theme.colors.textPrimary};
        }

        & .MuiPickersDay-root.Mui-disabled {
          color: ${({ theme }) => theme.colors.divider};
        }

        & .MuiPickersDay-root.Mui-selected {
          background-color: ${({ theme }) => theme.colors.primary};
          color: ${({ theme }) => theme.colors.white};
        }

        & .MuiPickersDay-today {
          border-color: ${({ theme }) => theme.colors.textPrimary};
        }

        & .MuiIconButton-root {
          color: ${({ theme }) => theme.colors.textPrimary};
        }
      }
    }
  }
`;
export const StyledAutocompletePopper = createGlobalStyle`
  :root {
    .MuiAutocomplete-popper {
      & .MuiAutocomplete-option {
        color: ${({ theme }) => theme.colors.textPrimary};
        font-size: 12px;
        padding: 12px 18px;

        &:hover {
          background-color: ${({ theme }) => theme.colors.background};
        }
      }

      & .MuiAutocomplete-paper {
        background-color: ${({ theme }) => theme.colors.secondaryBackground};
        padding: 0 2px;
      }

      & .MuiAutocomplete-noOptions {
        color: ${({ theme }) => theme.colors.textSecondary};
        background-color: ${({ theme }) => theme.colors.secondaryBackground};
      }

      & .MuiCheckbox-root {
        padding: 0 9px;
      }

      & .MuiFormControlLabel-label {
        font-size: 14px;
      }
    }
  }
`;
